import db from "../db/database";
import {
    fetchFromBusinessCentral,
    sendToBusinessCentral,
} from "../utils/businessCentralUtils";
import { getPendingSync, isOnline } from "./syncService";

// Función para transformar un colegio al formato esperado por Business Central
const transformColegioForBC = (colegio) => {
    // Transformar el colegio al formato esperado por BC
    const transformedColegio = {
        No: colegio.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
        Nombre: colegio.nombre,
        Deleted: colegio.deleted,
    };

    // Crear el formato final esperado por el endpoint
    return {
        data: JSON.stringify({ Colegios: [transformedColegio] }),
    };
};

export const syncColegios = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        const pendingColegios = await getPendingSync("colegios");

        // Enviar colegios pendientes uno por uno
        if (pendingColegios.length > 0) {
            console.log(`Sincronizando ${pendingColegios.length} colegios pendientes...`);

            for (const colegio of pendingColegios) {
                try {
                    // Si el colegio está marcado como eliminado, lo eliminamos directamente
                    if (colegio.deleted) {
                        await db.colegios.delete(colegio.id);
                        continue;
                    }

                    // Enviar colegio individual a Business Central
                    const response = await sendToBusinessCentral(
                        "Importaciones_insertaColegios",
                        transformColegioForBC(colegio),
                        true
                    );

                    // Verificar respuesta y actualizar el colegio con el No asignado por BC
                    if (response && response.value) {
                        const colegioNo = response.value;

                        console.log(`Colegio ${colegio.nombre} (ID: ${colegio.id}) sincronizado con No: ${colegioNo}`);

                        // Actualizar el colegio local con el No de BC
                        await db.colegios.update(colegio.id, {
                            No: colegioNo,
                            lastModified: new Date(),
                            lastSynced: new Date(),
                            pendingSync: 0,
                        });
                    } else {
                        console.error(`Error al sincronizar colegio ${colegio.id}: Respuesta inválida de BC`);
                    }
                } catch (error) {
                    console.error(`Error al sincronizar colegio ${colegio.id}:`, error);
                }
            }
        }


        const localColegios = await db.colegios.toArray();

        let lastSourceCode = null;

        if (localColegios.length > 0) {
            lastSourceCode = localColegios.sort((a, b) => a.Source_Counter - b.Source_Counter)[localColegios.length - 1].Source_Counter;
        }

        console.log("lastSourceCode", lastSourceCode);

        // Obtener colegioes del servidor solo después de sincronizar los pendientes
        const serverColegios = await fetchFromBusinessCentral("Colegios" + (lastSourceCode ? `?$filter=Source_Counter gt ${lastSourceCode}` : ""));

        // Mapa para buscar colegios locales por No rápidamente
        const localColegiosByNo = {};
        localColegios.forEach(colegio => {
            if (colegio.No) {
                localColegiosByNo[colegio.No] = colegio;
            }
        });

        // Actualizar colegios existentes y añadir nuevos desde el servidor
        for (const serverColegio of serverColegios) {
            // Verificar si el colegio ya existe localmente
            const localColegio = localColegiosByNo[serverColegio.No];

            if (localColegio) {
                // Actualizar colegio existente si no está pendiente de sincronización
                if (localColegio.pendingSync === 0) {
                    await db.colegios.update(localColegio.id, {
                        nombre: serverColegio.Nombre,
                        Source_Counter: serverColegio.Source_Counter,
                        lastModified: new Date(),
                        lastSynced: new Date(),
                    });
                }
            } else {
                // Añadir nuevo colegio del servidor si no existe localmente
                await db.colegios.add({
                    No: serverColegio.No,
                    nombre: serverColegio.Nombre,
                    Source_Counter: serverColegio.Source_Counter,
                    lastSynced: new Date(),
                    pendingSync: 0,
                    deleted: false,
                });
            }
        }

        return true;
    } catch (error) {
        console.error("Error al sincronizar colegios:", error);
        return false;
    }
}; 